<template>
  <div>
    <v-breadcrumbs :items="items" dark class="pa-2 pl-4">
      <v-icon slot="divider">chevron_right</v-icon>
      <template v-slot:item="{item}">
        <v-breadcrumbs-item :key="item.text"
                            :to="item.to"
                            :disabled="item.disabled"
                            class="font-weight-bold"
                            exact>
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
  export default {
    props: ['history', 'path'],
    data() {
      return {
        items: [
          { text: 'Home', to: '/', disabled: false }
        ],
        prevRoute: {}
      };
    },
    mounted() {
      if (this.path != null) {
        let basePath = this.path === '' ? this.$store.state.route.path : this.path;
        basePath = basePath.match(/\/?(.*)/)[1];
        basePath.split('/').slice(0, -1).reduce((acc, el) => {
          const p = acc.slice(-1) + '/' + el;
          this.items.push({ text: this.$router.match(p).name, to: p, disabled: false });
          acc.push(p);
          return acc
        }, [])
      }
      if (this.history != null &&
        this.$store.state.route.from &&
        this.$store.state.route.from.path !== '/' &&
        this.$store.state.route.from.path !== this.items.slice(-1)[0].to) {
        this.items.push({
          text: this.$router.match(this.$store.state.route.from.path).name,
          to: this.$store.state.route.from.path,
          disabled: false
        })
      }
      this.items.push({
        text: this.$store.state.route.name,
        to: this.$store.state.route.path,
        disabled: true
      })
    }
  }
</script>

<style scoped>
</style>
